var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.canShowChart)?_c('PieChart',{attrs:{"config":_vm.chartConfig,"width":"100%","height":"100%"},on:{"frame-ended":_vm.setIdle}}):_vm._e(),(_vm.canShowComparisonChart)?_c('PieChart',{attrs:{"config":_vm.comparisonChartConfig,"width":"100%","height":"100%","is-comparison":""},on:{"frame-ended":_vm.setIdle}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }